import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Edit as EditIcon } from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Box,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from '@mui/material';
import {
  CheckCircle,
  Cancel,
  Visibility,
  AddCircleOutline,
  Visibility as VisibilityIcon,
  PendingActions,
  Comment,
  Reviews
} from '@mui/icons-material';
import axios from 'axios';
import LoadingScreen from './LoadingScreen';

const Request = () => {
const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editRequestId, setEditRequestId] = useState(null);


  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [closeComment, setCloseComment] = useState('');
  const [closingRequestId, setClosingRequestId] = useState(null);

  const token = localStorage.getItem('token');
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [criticality, setCriticality] = useState('');
  const [justification, setJustification] = useState('');

  const [view, setView] = useState('raise');
  const [industries, setIndustries] = useState([]);
  const [industry, setIndustry] = useState('');
  const [helpneed, sethelpneed] = useState('');
  const [helpneedlst, sethelpneedlst] = useState([]);
  const [question, setQuestion] = useState('');
  const [requests, setRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [answer, setAnswer] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [pageSize, setPageSize] = useState(10);  // Default to 10 rows per page
  const [page, setPage] = useState(0);
  const username = localStorage.getItem('username') || 'Anonymous';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if screen size is mobile
  const [requestTo, setRequestTo] = useState('');
  const [moderatorType, setModeratorType] = useState('');
  const [answers, setAnswers] = useState([]);
  const [isprovider, setisprovider] = useState(localStorage.getItem('isprovider'));

  const [requestnumber, serrequestnumber] = useState('');

  // const [resumeFile,setresumeFile]=useState([''])
  const [resumeFiles, setResumeFiles] = useState([]);
  const [uploadedResumeFiles,setUploadedResumeFiles]=useState([])
  const [deletedFileIds, setDeletedFileIds] = useState([]);

  useEffect(() => { 
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/validateAdmin`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then(() => setIsAdmin(true)).catch(() => setIsAdmin(false));
    }
  }, []);

  const handleEditRequest = async (request) => {
  //getfile list
  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${request.id}/attachments`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  setUploadedResumeFiles(response.data); 

  serrequestnumber(request.request_number)
  setRequestTo(request.requestTo);
  setIndustry(request.industry);
  sethelpneed(request.helpneed)
  setQuestion(request.question);
  setCriticality(request.criticality || '');
  setJustification(request.justification || '');
  setModeratorType(request.moderatorType || '');
  setEditRequestId(request.id);
  setResumeFiles([])
  setIsEditing(true);
  setView('raise');

  };


  const handleRequestToChange = async (e) => {
    const value = e.target.value;
    setRequestTo(value); 
    if (value === 'Providers') {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/checkOpenRequests`, {
          headers: { Authorization: `Bearer ${token}` }
        });
  
        const hasOpenRequest = response.data?.hasOpenRequest;
  
        if (hasOpenRequest) {
          alert("You have an open request. Please close it to create a new one.");
          setRequestTo(''); // Reset the selection
        }
  
      } catch (error) {
        console.error("Error checking open requests", error);
        alert("Failed to check open requests.");
      }
    }
  };
  

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getIndustries`)
      .then((res) => setIndustries(res.data.industries))
      .catch((err) => console.error('Error fetching industries', err));
  }, []);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/gethelpneeded`)
      .then((res) => sethelpneedlst(res.data.industries))
      .catch((err) => console.error('Error fetching industries', err));
  }, []);
  const handleViewClick = async (request) => {
    setSelectedRequest(request);
    try {
       setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getAnswersForRequest/${request.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const response_attachment = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${request.id}/attachments`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUploadedResumeFiles(response_attachment.data|| []); 
      setAnswers(response.data || []);
      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching answers', err);
      setIsLoading(false);
    }
     
  };  
  const handleSubmit = () => {
    if (criticality === 'High' && !justification) {
      alert('Please provide justification for high criticality.');
      return;
    }

      const formData = new FormData();
    // Append basic fields
      formData.append('requestTo', requestTo);
      if (requestTo === 'Providers') {
        formData.append('helpneed', helpneed);
        formData.append('industry', industry);
        formData.append('criticality', criticality);
        if (criticality === 'High') {
          formData.append('justification', justification);
        }else{
          formData.append('justification', '');
        }
      } else if (requestTo === 'Moderators') {
        formData.append('moderatorType', moderatorType);
      }
      formData.append('question', question);
      // Append multiple files
      resumeFiles.forEach((file, index) => {
        formData.append('attachments', file); // name 'attachments' should match backend field name
      });
      formData.append('deletedFileIds', JSON.stringify(deletedFileIds))
      formData.append('request_number', requestnumber)
      const requestCall = isEditing
      ? axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateRequest/${editRequestId}`, formData, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data', },
        })
      : axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/submitRequest`, formData, {
          headers: { Authorization: `Bearer ${token}`}
        });
        
    requestCall
      .then(() => {
        alert(isEditing ? 'Request updated successfully!' : 'Request submitted successfully!');
        setRequestTo('')
        setModeratorType('')
        setIndustry('');
        setQuestion('');
        setCriticality('');
        setJustification('');
        setEditRequestId(null);
        setIsEditing(false);
        setResumeFiles([])
        setUploadedResumeFiles([])
        setDeletedFileIds([])
        setView('view');
      })
      .catch(() => alert('Submission failed.'));
  };

  useEffect(() => {
    const fetchRequests = async () => {
       setIsLoading(true);
      try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/api/getRequests`; 
        if (view === 'view') {
          if(isAdmin){
            url += '?get=all'
          }else{
            url += '?get=user'
          } 
        } else if (view === 'pendingApproval') {
          url += `?status=Pending Approval`;
        } else if (view === 'pendingComments') {
          url += `?status=Approved`;
        }  
        else if (view === 'feedbacks') {
          url += `?type=providers`;
        }  
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setRequests(response.data);
        setIsLoading(false);
      } catch (err) {
        console.error('Error fetching requests', err);
        setIsLoading(false);
      } 
    };  
    if(view!='raise'){
      setRequests([]) 
      fetchRequests();
      setRequestTo('')
        setModeratorType('')
        setIndustry('');
        setQuestion('');
        setCriticality('');
        setJustification('');
        setEditRequestId(null);
        setResumeFiles([])
        setUploadedResumeFiles([])
        setIsEditing(false);
    } 
  }, [view, username,refreshFlag]);

  const handleApproval = (id, status) => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateRequestStatus/${id}`, {
      id, status
    },{
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      alert(`Request ${status.toLowerCase()} successfully!`);
      setRequests((prev) => prev.map((r) => (r.id === id ? { ...r, status, approvedBy: username } : r)));
    }).catch(() => alert('Failed to update request status'));
  };

  const handleAnswerSubmit = (id,request_number) => {
    if (!answer) return alert('Answer is required');
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/updateAnswer`, {
      requestId: id,
      answer, 
      requestnumber:request_number
    },{
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      alert('Answer submitted successfully!');
      setAnswer('');
      setSelectedRequest(null); 
      setRefreshFlag(prev => !prev);
    }).catch(() => alert('Failed to submit answer'));
  };


  const openCloseDialog = (id) => {
    setClosingRequestId(id);
    setCloseDialogOpen(true);
  };
  
  const handleCloseRequest = () => {
    if (!closeComment.trim()) {
      alert("Please provide a comment to close the request.");
      return;
    } 
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/closeRequest/${closingRequestId}`, {
      comment: closeComment,      
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(() => {
      alert("Request closed successfully!");
      setCloseDialogOpen(false);
      setCloseComment('');
      setClosingRequestId(null);
      setRefreshFlag(prev => !prev);
    }).catch(() => {
      alert("Failed to close request.");
    });
  };

  const columns = [
    ...(view === 'view' ? [{
      field: 'moderatorType',
      headerName: 'Type',
      flex: 1,
      minWidth: 150
    }] : [])
   ,
   {
      field: 'request_number', headerName: 'Request Number', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'helpneed', headerName: 'Help Need', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'industry', headerName: 'Industry', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'criticality',
      headerName: 'Criticality',
      width: 130,
      renderCell: (params) => {
        const value = params.value;
        const color =
          value === 'High' ? 'red' :
          value === 'Medium' ? 'orange' :
          'green';
        return (
          <span style={{ color, fontWeight: 'bold' }}>
            {value}
          </span>
        );
      },
    },
    {
      field: 'question', headerName: 'Question', flex: 2, minWidth: 250,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },
    {
      field: 'submittedBy',
      headerName: 'Submitted By',
      width: 150,
    },
    {
      field: 'submittedDate',
      headerName: 'Submitted Date',
      width: 180,
      renderCell: (params) => {
        const rawDate = params.value;
        const date = new Date(rawDate);
    
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
    
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');
    
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
      },
    }, 
    {
      field: 'answerCount', headerName: 'Answers', flex: 1, minWidth: 150,
      cellClassName: 'wrap-text', // Add class for text wrapping
    },   
    {
      field: 'status', headerName: 'Status', flex: 1, minWidth: 150,
      renderCell: (params) => (
        <Chip label={params.value} color={params.value === 'Pending Approval' ? 'warning' :
          params.value === 'Approved' ? 'success' :
            params.value === 'Rejected' ? 'error' : 'default'}
        />
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View">
            <IconButton onClick={() => handleViewClick(params.row)}>
              <Visibility />
            </IconButton>
          </Tooltip>
          {isAdmin && view === 'pendingApproval' && params.row.status === 'Pending Approval' && (
            <>
              <Tooltip title="Approve">
                <IconButton color="success" onClick={() => handleApproval(params.row.id, 'Approved')}>
                  <CheckCircle />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reject">
                <IconButton color="error" onClick={() => handleApproval(params.row.id, 'Rejected')}>
                  <Cancel />
                </IconButton>
              </Tooltip>
            </>
          )}
          {(view === 'view' || view === 'pendingComments') && params.row.status !== 'Closed' && params.row.status !== 'Rejected' && (
          <Tooltip title="Close Request">
            <IconButton onClick={() => openCloseDialog(params.row.id)}>
              <Reviews color="warning" />
            </IconButton>
          </Tooltip>
          )}
          {view === 'view' &&
          params.row.status !== 'Closed' && 
          params.row.status !== 'Rejected' && (
            <Tooltip title="Edit">
              <IconButton onClick={() => handleEditRequest(params.row)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];
  const feedbackColumns = [
  { field: 'moderatorType', headerName: 'Type', flex: 1, minWidth: 150 },
  { field: 'question', headerName: 'Comments', flex: 2, minWidth: 250, cellClassName: 'wrap-text' },
  { field: 'submittedBy', headerName: 'Submitted By', width: 150 },
  {
    field: 'submittedDate',
      headerName: 'Submitted Date',
      width: 180,
      renderCell: (params) => {
        const rawDate = params.value;
        const date = new Date(rawDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      renderCell: (params) => (
        <Tooltip title="View Details">
          <IconButton onClick={() => setSelectedRequest(params.row)}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const isSubmitDisabled =
  !requestTo ||
  (requestTo === 'Moderators' && (!moderatorType || !question.trim())) ||
  (requestTo === 'Providers' &&
    (!helpneed || !industry || !criticality || !question.trim() || (criticality === 'High' && !justification.trim())));
 return isLoading ? <LoadingScreen /> : (
    <Box sx={{ p: 2 }}>
      <Tabs
        value={view}
        onChange={(e, newValue) => setView(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        indicatorColor="primary"
        textColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab value="raise" icon={<AddCircleOutline />} iconPosition="start" label="Raise Request" />
        <Tab value="view" icon={<VisibilityIcon />} iconPosition="start" label="View Request" />
        {isprovider=='yes'&&(<Tab value="pendingComments" icon={<Comment />} iconPosition="start" label="Open Requests" />)} 
        {isAdmin && <Tab value="pendingApproval" icon={<PendingActions />} iconPosition="start" label="Pending Approval" />} 
        {isAdmin && <Tab value="feedbacks" icon={<Reviews />} iconPosition="start" label="Feedback & Issues" />}
      </Tabs>

      {view === 'raise' && (
        <Box sx={{ mt: 2 }} >   
            <FormControl fullWidth sx={{ mt: 2,mb: 2 }}>
              <InputLabel>Request To</InputLabel>
              <Select disabled={isEditing} value={requestTo} onChange={handleRequestToChange} label="Request To">
                <MenuItem value="Providers">Providers</MenuItem>
                <MenuItem value="Moderators">Moderators</MenuItem>
              </Select>
            </FormControl>
            {requestTo === 'Moderators' && (
            <FormControl fullWidth sx={{ mt: 2,mb: 2 }}>
              <InputLabel>Type</InputLabel>
              <Select value={moderatorType} onChange={(e) => setModeratorType(e.target.value)} label="Type">
                <MenuItem value="Feedback">Feedback</MenuItem>
                <MenuItem value="Issue">Issue</MenuItem>
              </Select>
            </FormControl>
            )}
            {requestTo === 'Providers' && (
            <> 
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>What help you need ?*</InputLabel>
              <Select value={helpneed} onChange={(e) => sethelpneed(e.target.value)} label="What help you need ?">
              {helpneedlst.map((ind) => <MenuItem key={ind} value={ind}>{ind}</MenuItem>)}
              </Select>
             </FormControl> 
             <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Industry *</InputLabel>
              <Select value={industry} onChange={(e) => setIndustry(e.target.value)} label="Industry">
              {industries.map((ind) => <MenuItem key={ind} value={ind}>{ind}</MenuItem>)}
              </Select>
             </FormControl> 
            <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Criticality</InputLabel>
            <Select
              value={criticality}
              onChange={(e) => setCriticality(e.target.value)}
              label="Criticality"
            >
              <MenuItem value="Low">Low</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="High">High</MenuItem>
            </Select>
            </FormControl>
            {criticality === 'High' && (
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Justification for High Criticality"
                value={justification}
                onChange={(e) => setJustification(e.target.value)}
                sx={{ mb: 2 }}
              />
            )} 
            </>
            )}
            {requestTo&&(
              <TextField
              fullWidth
              multiline
              rows={4}
              label={
                requestTo === 'Moderators'
                  ? moderatorType === 'Feedback' ? 'Your Feedback' :
                    moderatorType === 'Issue' ? 'Describe the Issue' :
                    'What do you want to share?'
                  : 'What help do you need?'
              }
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              sx={{ mb: 2 }}
            />
            )} 
            {requestTo === 'Providers' && (
           <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
              {/* Upload Button */}
              <Button
                variant="contained"
                component="label"
                sx={{ mb: 0 }}
              >
                Upload Attachment
                <input
                    type="file"
                    hidden
                    multiple
                    accept=".pdf,.doc,.docx"
                    onChange={e => {
                      const filesArray = Array.from(e.target.files);
                      setResumeFiles(prev => [...prev, ...filesArray]);
                    }}
                  />
              </Button>
              {/* Show existing uploaded resume link */}
              {uploadedResumeFiles?.map((file, index) => (
                <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Link
                    href={`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${file.id}/download`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                  >
                    {file.filename}
                  </Link>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => {
                      setUploadedResumeFiles(prev => prev.filter((_, i) => i !== index));
                      setDeletedFileIds(prev => [...prev, file.id]); // Track deleted file
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
              {/* Show newly selected resume file */}
              {resumeFiles.length > 0 &&
              resumeFiles.map((file, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body2" noWrap maxWidth={200}>
                    {file.name}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setResumeFiles(prev => prev.filter((_, i) => i !== index));
                    }}
                    color="error"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>+
                </Box>
              ))}

              {/* Show message if no file at all */}
              {!uploadedResumeFiles && resumeFiles.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                  No attachment
                </Typography>
              )}
            </Box>
           </FormControl>
             
            )}
           
            <Button variant="contained" onClick={handleSubmit} disabled={isSubmitDisabled}> {isEditing ? 'Update' : 'Submit'}</Button>
        </Box>
      )}

      {['view', 'pendingApproval', 'pendingComments','feedbacks'].includes(view) && (
        <Box sx={{ mt: 2, height: 400 }}>
          <DataGrid
            rows={requests}
            columns={view === 'feedbacks' ? feedbackColumns : columns}
            pageSize={pageSize}
            pageSizeOptions={[5, 10, 15]}
            paginationModel={{ pageSize, page }}
            onPaginationModelChange={(model) => {
              setPage(model.page);
              setPageSize(model.pageSize);
            }}
            //rowsPerPageOptions={[5, 10, 15]}  // Row options for mobile
            //onPageSizeChange={(newSize) => setPageSize(newSize)}
            getRowId={(row) => row.id} 
            disableSelectionOnClick
            sx={{
              '& .wrap-text': {
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                overflow: 'hidden',
              },
              '& .MuiDataGrid-virtualScroller': {
                overflowY: 'auto',
              },
              '& .MuiDataGrid-root': {
                overflowX: 'auto',
              },
              '& .MuiDataGrid-columnHeaders': {
                minHeight: '40px',
              },
              '& .MuiTablePagination-toolbar': {
                flexWrap: 'wrap',         // Allows content to wrap on small screens
                justifyContent: 'center', // Center-aligns the pagination controls
              },
            }}
          />
        </Box>
      )}


      <Dialog open={!!selectedRequest} onClose={() => setSelectedRequest(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Request Details</DialogTitle>
        <DialogContent>
          {selectedRequest && (
            <>
              {view!='feedbacks' &&(
                <>
                  <Typography><strong>Help Need:</strong> {selectedRequest.helpneed}</Typography>
                  <Typography><strong>Industry:</strong> {selectedRequest.industry}</Typography>
                  <Typography><strong>Criticality:</strong> {selectedRequest.criticality}</Typography>
                  {selectedRequest.criticality=='High' && (
                    <>
                      <Typography><strong>Justification:</strong> {selectedRequest.justification}</Typography>               
                    </>
                  )}
                  <Typography><strong>Request:</strong> {selectedRequest.question}</Typography>
                  <Typography><strong>Status:</strong> {selectedRequest.status}</Typography>
                </> 
              )}      
              {view=='feedbacks' &&(
                <>
                  <Typography><strong>Type:</strong> {selectedRequest.moderatorType}</Typography>
                  <Typography><strong>Comments:</strong> {selectedRequest.question}</Typography>
                </> 
              )} 
              <Typography><strong>Attachments:</strong>
              {uploadedResumeFiles?.map((file, index) => (
                <Box key={file.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Link
                    href={`${process.env.REACT_APP_API_BASE_URL}/api/request/attachment/${file.id}/download`}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                  >
                    {file.filename}
                  </Link>
                </Box>
              ))}
              </Typography>
              <Typography><strong>Submitted By:</strong> {selectedRequest.submittedBy}</Typography>
              <Typography>
                <strong>Submitted On:</strong>{' '}
                {(() => {
                  const date = new Date(selectedRequest.submittedDate);
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, '0');
                  const day = String(date.getDate()).padStart(2, '0');
                  let hours = date.getHours();
                  const minutes = String(date.getMinutes()).padStart(2, '0');
                  const ampm = hours >= 12 ? 'PM' : 'AM';
                  hours = hours % 12 || 12;
                  hours = String(hours).padStart(2, '0');
                  return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
                })()}
              </Typography>
              {answers?.length>0 && (
                <>
                  {/* <Typography><strong>Answer:</strong> {selectedRequest.answer}</Typography>
                  <Typography><strong>Answered By:</strong> {selectedRequest.answeredBy}</Typography> */}
                  <Box sx={{ mt: 2 }}>
                    <Typography variant="h6">Answers</Typography>
                    {answers?.length > 0 ? (
                        answers.map((ans, index) => (
                        <Box key={index} sx={{ mb: 1, p: 1, border: '1px solid #ccc', borderRadius: 1 }}>
                          <Typography><strong>{ans.answeredBy}</strong> ({dayjs(ans.answeredDate).format('YYYY-MM-DD HH:mm')}):</Typography>
                          <Typography>{ans.answer}</Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography>No answers yet.</Typography>
                    )}
                  </Box>
                </>
              )}
              {view === 'pendingComments' && selectedRequest.status === 'Approved' && (
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Your Answer"
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  sx={{ mt: 2 }}
                />
              )}
              {selectedRequest.status==='Closed'&&(
                <>
                <Typography variant="h6">Closer Info:</Typography>
                <Typography><strong>Closed By:</strong> {selectedRequest.closedBy}</Typography>
                <Typography><strong>Closed On:</strong>  ({dayjs(selectedRequest.closedDate).format('YYYY-MM-DD HH:mm')})</Typography>
                <Typography><strong>Comments:</strong> {selectedRequest.closeComment}</Typography>
                </> 
              )}
               
            </>
          )}
        </DialogContent>
        <DialogActions>
          {view === 'pendingComments' && selectedRequest?.status === 'Approved' && (
            <Button onClick={() => handleAnswerSubmit(selectedRequest.id,selectedRequest.request_number)} disabled={!answer} variant="contained">Submit Answer</Button>
          )}
          <Button onClick={() => {setSelectedRequest(null);setAnswers(null)}}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={closeDialogOpen} onClose={() => setCloseDialogOpen(false)} fullWidth>
        <DialogTitle>Close Request</DialogTitle>
        <DialogContent>
          <TextField
            label="Close Comment"
            fullWidth
            multiline
            minRows={3}
            value={closeComment}
            onChange={(e) => setCloseComment(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCloseDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleCloseRequest}>
            Submit
          </Button>
        </DialogActions>
    </Dialog>

    </Box>
  );
};

export default Request;
